<template>
    <!-- <van-overlay :show="showTip" :lock-scroll="false" @click="showTip = false" z-index="3001">
        <div class="dialog" @click.stop>
            <div class="title">
                {{ title }}
                <div class="close" @click="showTip = false"></div>
            </div>
            <div class="content" v-html="content"></div>
            <div class="confirm" @click="showTip = false">{{ $t('Confirm') }}</div>
        </div>
    </van-overlay> -->
    <GeneralDialog v-model="showTip" :title="title">
        <div class="dialog" @click.stop>
            <div class="content" v-html="content"></div>
            <div class="confirm" @click="showTip = false">{{ $t('Confirm') }}</div>
        </div>
    </GeneralDialog>
</template>
<script setup lang="ts">
import GeneralDialog from '@/components/dialog/generalDialog.vue'
defineProps({
    title: {
        type: String,
        default: () => '',
    },
    content: {
        type: String,
        default: () => '',
    },
})

const showTip = defineModel()
</script>
<style lang="scss" scoped>
.dialog {
    @apply flex flex-col;
    height: 840px;
    padding: 0 28px 60px;
    font-family: MicrosoftYaHei;
    color: #ffffff;

    .content {
        flex: 1;
        overflow-y: scroll;
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 60px;
        letter-spacing: -1px;
    }
    .confirm {
        margin: 20px auto 0;
        width: 440px;
        height: 88px;
        line-height: 88px;
        background-image: linear-gradient(0deg, #fa3374 0%, #fd578d 60%, #ff7aa5 100%), linear-gradient(#e59e20, #e59e20);
        background-blend-mode: normal, normal;
        border-radius: 44px;
        text-align: center;
        font-size: 36px;
        color: #ffffff;
    }
}
</style>
